package com.eladfinish.bible.contest.screens.chapterComplete.model

import com.eladfinish.bible.contest.screens.chapterComplete.model.RemoteCompletionJsonKeys.BLANKS
import com.eladfinish.bible.contest.screens.chapterComplete.model.RemoteCompletionJsonKeys.BOOK_INDEX
import com.eladfinish.bible.contest.screens.chapterComplete.model.RemoteCompletionJsonKeys.CHAPTER_INDEX
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Developed by
 * @author Elad Finish
 */

@Serializable
data class Author(
    @SerialName("id") val id: String? = "",
    @SerialName("username") val username: String? = null,
)

@Serializable
data class BlanksRecord(
    @SerialName("_id") val id: String? = "",
    @SerialName("pickedBookHeb") val bookHeb: String,
    @SerialName("pickedBookIndex") val bookIndex: Int,
    @SerialName("pickedChapterIndex") val chapterIndex: Int,
    @SerialName("createdAt") val createdAt: Long,
    @SerialName("author") val author: Author,
    @SerialName("indexes") val indexes: Map<String, List<Int>>,
)

typealias BlanksData = Map<String, BlanksRecord>

object RemoteCompletionJsonKeys {
    const val BOOK_INDEX = "bookIndex"
    const val CHAPTER_INDEX = "chapter"
    const val BLANKS = "blanks"
}

@Serializable
data class SavedCompletionData(
    @SerialName("pickedBookEng") val pickedBookEng: String = "",
    @SerialName("pickedBookHeb") val pickedBookHeb: String = "",
    @SerialName(BOOK_INDEX) val bookIndex: Int,
    @SerialName(CHAPTER_INDEX) val chapter: Int,
    @SerialName(BLANKS) val blanks: List<List<Int>>,
)
